import React, { FunctionComponent } from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Stack,
  AlertDialogCloseButton,
  Box,
  Button,
  Text,
} from "@chakra-ui/react";

type Props = {
  isOpen: boolean;
  handleClose: () => void;
  label?: string;
  title?: string;
  ref: React.RefObject<HTMLInputElement>;
  handleClick?: () => void;
  isLoading: boolean;
  btnPrimaryLabel?: string;
  btnSecondaryLabel?: string;
  headingSize?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  btnPrimaryVariant?: "primary" | "secondary" | "tertiary";
  btnPrimarySize?: "sm" | "md" | "lg";
  hideButton?: boolean;
  bgColor?: string;
  dialogIcon?: any;
};

export const CustomDialog: FunctionComponent<Props> = ({
  isOpen,
  handleClose,
  ref,
  label,
  title,
  handleClick,
  isLoading,
  btnPrimaryLabel,
  btnSecondaryLabel,
  btnPrimaryVariant,
  btnPrimarySize,
  hideButton,
  bgColor,
  dialogIcon,
}) => {
  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={handleClose}
      closeOnOverlayClick={false}
      leastDestructiveRef={ref}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize={"16px"}>{title}</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody pb={hideButton ? 10 : 0}>
            <Box
              width={"50%"}
              textAlign={"center"}
              margin={"auto"}
              display={"flex"}
              alignItems={"center"}
              flexDirection={"column"}
              mb={5}
            >
              <img
                src={dialogIcon}
                style={{
                  width: "60px",
                  height: "60px",
                  textAlign: "center",
                }}
              />
            </Box>
            <Text textAlign={"center"} fontSize={"14px"}>
              {label}
            </Text>
          </AlertDialogBody>
          <AlertDialogFooter display={hideButton ? "none" : "unset"}>
            <Stack direction={"row"} width={"100%"}>
              <Button
                width={"100%"}
                onClick={handleClose}
                size={"md"}
                variant={"outline"}
              >
                {btnSecondaryLabel || "No"}
              </Button>
              <Button
                onClick={handleClick}
                variant={btnPrimaryVariant || "danger"}
                size={btnPrimarySize || "sm"}
                width={"100%"}
                isLoading={isLoading}
                background={bgColor || "primary"}
                color={"#fff"}
              >
                {btnPrimaryLabel || "Yes"}
              </Button>
            </Stack>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
